// extracted by mini-css-extract-plugin
export default {"root":"PpcComplianceTable_root__zBDY4","columnTitle":"PpcComplianceTable_columnTitle__qjRIE"};